import React, { useEffect, useState } from "react"
import { createPortal } from "react-dom"

export function Modal({ children, isOpen = false, onCancel, showIcon = true }) {
  const [isClient, setClient] = useState(false)
  const handleEscape = (event) => {
    if (event.keyCode === 27) onCancel()
  }
  useEffect(() => {
    setClient(true)
  }, [])

  useEffect(() => {
    if (isOpen) {
      if (document.body.style.overflow !== "hidden") {
        document.body.style.overflow = "hidden"
        document.body.style.width = "calc(100% - 8px)"
      }
      document.addEventListener("keydown", handleEscape, false)
    }
    return () => {
      document.removeEventListener("keydown", handleEscape, false)
      document.body.style.overflow = null
      document.body.style.width = null
    }
  }, [handleEscape, isOpen])

  const modalContent = isOpen ? (
    <div className="modal modal-fade">
      <div className="modal-overlay" onClick={onCancel} />
      <div className="modal-body">
        {showIcon && (
          <button className="absolute z-10 top-3 right-5" onClick={onCancel}>
            <img src="/icons/iconBigClose.svg" />
          </button>
        )}
        {children}
      </div>
    </div>
  ) : null

  if (isClient) {
    return createPortal(modalContent, document.getElementById("modal-root"))
  } else {
    return null
  }
}

export default Modal
